/**
 * Runtime environment configuration helper.
 * 
 * In Docker, environment variables are injected at container startup via
 * window.__ENV__ (see docker-env-inject.sh). This helper checks for runtime
 * values first, then falls back to Vite build-time values.
 * 
 * Usage:
 *   import { getEnv } from '@/utils/env'
 *   const apiUrl = getEnv('VITE_VITRAIL_API')
 */

/**
 * Get an environment variable value.
 * Priority: window.__ENV__ (runtime) > import.meta.env (build-time)
 * 
 * @param {string} key - The environment variable name (e.g., 'VITE_VITRAIL_API')
 * @param {string} [fallback=''] - Default value if not found
 * @returns {string} The environment variable value
 */
export function getEnv(key, fallback = '') {
  // Check runtime injected values first (Docker)
  if (window.__ENV__ && window.__ENV__[key]) {
    return window.__ENV__[key]
  }
  // Fall back to Vite build-time values
  return import.meta.env[key] || fallback
}
